var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.515,
    height: 16.886,
    viewBox: "0 0 22.515 16.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email-2",
    "data-name": "email",
    d: "M18.763,3H3.753A3.764,3.764,0,0,0,0,6.753v9.381a3.764,3.764,0,0,0,3.753,3.753h15.01a3.764,3.764,0,0,0,3.753-3.753V6.753A3.764,3.764,0,0,0,18.763,3Zm1.5,5.441-7.411,4.972a3.163,3.163,0,0,1-1.595.469,3.163,3.163,0,0,1-1.595-.469L2.252,8.441a.992.992,0,0,1-.188-1.313A.992.992,0,0,1,3.377,6.94l7.411,4.972a1.016,1.016,0,0,0,1.032,0L19.232,6.94a.923.923,0,0,1,1.313.281A1.023,1.023,0,0,1,20.264,8.441Z",
    transform: "translate(0 0)",
    fill: "#8fa2bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.38b0c61ae6e9f1eb50e2d52b69bd237f.svg";
export { ForwardRef as ReactComponent };